import { ClipboardList, EllipsisVertical, GitBranch } from "lucide-mui";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import type { MasterCompanyDetail } from "../../../api/client.ts";
import CountryName from "../../../components/CountryName.tsx";
import DropdownMenu from "../../../components/DropdownMenu.tsx";
import PageHeader from "../../../components/PageHeader.tsx";
import { useTenant } from "../../../contexts/TenantContext.tsx";

interface CompanyHeaderProps {
  company: MasterCompanyDetail;
  selectedTenantId: string | null;
  addToListPending: boolean;
  onAddToListClick: () => void;
  onSplitClick: () => void;
}

export default function CompanyHeader({
  company,
  selectedTenantId,
  addToListPending,
  onAddToListClick,
  onSplitClick,
}: CompanyHeaderProps) {
  const { tenantPath } = useTenant();
  return (
    <PageHeader
      back={{ to: tenantPath("/companies"), label: "Companies" }}
      title={company.name}
      description={
        <Stack direction="row" spacing={1} useFlexGap sx={{ flexWrap: "wrap", alignItems: "center", mt: 0.5 }}>
          <Chip label={<CountryName code={company.country} />} />
          {company.org_form && <Chip label={company.org_form} />}
          {company.ai_industries?.map((ind) => <Chip key={ind} label={ind} />)}
          {company.ai_served_verticals?.map((v) => <Chip key={v} label={v} />)}
        </Stack>
      }
      actions={
        <>
          {selectedTenantId && (
            <Button
              variant="contained"
              startIcon={<ClipboardList />}
              onClick={onAddToListClick}
              loading={addToListPending}
              loadingPosition="start"
            >
              Add to collection
            </Button>
          )}
          <DropdownMenu aria-label="More actions" icon={<EllipsisVertical />} align="right">
            <MenuItem onClick={onSplitClick}>
              <ListItemIcon>
                <GitBranch fontSize="small" />
              </ListItemIcon>
              <ListItemText>Split company</ListItemText>
            </MenuItem>
          </DropdownMenu>
        </>
      }
    />
  );
}
